export default __webpack_public_path__ + "static/media/6.df0c198f.png";